<template>
  <div class="substep-get-familiar-with-hubstaff">
    <div class="substep-header">
      <h3 data-testid="step-title">Get familiar with Hubstaff</h3>
      <p>Check out the video below and learn more about how to use Hubstaff</p>
    </div>

    <div class="substep-body">
      <div class="substep-storylane-embed">
        <iframe
          ref="storylaneFrame"
          :src="embedUrl"
          title="Hubstaff interactive demo"
          loading="lazy"
          allow="fullscreen"
          allowfullscreen
        />
      </div>
    </div>
  </div>
</template>

<script>
const STORYLANE_INTERACTION_EVENTS = [
  'step_view',
  'primary_cta',
  'secondary_cta',
  'convert_cta',
  'open_external_url',
  'checklist_item_view',
  'flow_start',
  'flow_end',
  'page_view',
  'lead_identify',
];

export default {
  name: 'GetFamiliarWithHubstaff',
  props: {
    storylaneUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hasTrackedInteraction: false,
    };
  },
  computed: {
    embedUrl() {
      return `${this.storylaneUrl}?embed=inline`;
    },
    storylaneOrigin() {
      return new URL(this.storylaneUrl).origin;
    },
  },
  mounted() {
    this.$emit('completeSubstep');
    window.addEventListener('message', this.handleStorylaneMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleStorylaneMessage);
  },
  methods: {
    handleStorylaneMessage(event) {
      if (this.hasTrackedInteraction) {
        return;
      }
      if (event.origin !== this.storylaneOrigin) {
        return;
      }
      if (event.source !== this.$refs.storylaneFrame?.contentWindow) {
        return;
      }
      if (event.data?.message !== 'storylane-demo-event') {
        return;
      }
      if (!STORYLANE_INTERACTION_EVENTS.includes(event.data.payload?.event)) {
        return;
      }

      this.hasTrackedInteraction = true;
      window.analytics?.track('0223 User Getting Started V2 Storylane Interaction', {
        props: { step: 'get_familiar_with_hubstaff' },
      });
    },
  },
};
</script>
